import {GlobalAttributeIdKeyBuilder} from '@viamedici-spc/configurator-ts';
import {attributeMigrations} from '../attributeMigration';
import {attributeKeyToId} from '../components/spc/util/spcUtils';
import {spcExpliciteChoiceDecision} from './values';

export function migrateDecisions(sourceDecisions, mode, model) {
	console.log('migrateDecisions', sourceDecisions, mode, model);

	const usageDecision = spcExpliciteChoiceDecision('shared::ContextV3::CX_Usage', mode);
	const modelDecision = spcExpliciteChoiceDecision('shared::ProductType::HS_HousingType', model);

	const targetDecisions = [usageDecision, modelDecision];

	sourceDecisions.forEach(decision => {

		const type = decision.type;
		const sourceId = decision.attributeId;
		const value = decision.choiceValueId;
		const state = decision.state;

		//find the migration based on the sourceId (localId)
		const attributeMigration = attributeMigrations.find(m => m.source === sourceId.localId);

		if (attributeMigration) {
			//console.log('migrating decision', decision, attributeMigration);
			// check all migrations
			attributeMigration.migrations.forEach(migration => {
				//console.log('target', migration.target);
				const targetId = attributeKeyToId(migration.target);
				//console.log('targetId', targetId);
				// same values
				if (migration.valueMapping === null) {
					// no mapping, just transfer the value
					const targetDecision = {
						attributeId: targetId,
						choiceValueId: value,
						state: state,
						type: type
					};
					targetDecisions.push(targetDecision);
					//console.log('migration found for', decision, targetDecision);
				} else {
					// create target decisions only if the value is in valueMapping and source
					const valueMap = migration.valueMapping.find(vm => vm.source === value);
					if (valueMap) {
						const targetDecision = {
							attributeId: targetId,
							choiceValueId: valueMap.target,
							state: state,
							type: type
						};
						targetDecisions.push(targetDecision);
						//console.log('migration (valuemapped) found for', decision, targetDecision);
					} else {
						console.log('no value mapping found for', decision, migration);
					}
				}
			});
		} else {
			console.log('no migration found for', decision);
		}

	});
	console.log('migrateDecisions', sourceDecisions, targetDecisions);
	return targetDecisions;
}
